import React from "react";
import { useParams, Link } from "react-router-dom";
import { Calendar, User, ArrowLeft, ArrowRight } from "lucide-react";
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";
import PageBanner from "../components/PageBanner";
import ContactCta from "../components/homi/ContactCta";
import { useContent } from "../context/ContentContext";

export default function BlogDetailPage() {
  const { slug } = useParams();
  const { content } = useContent();
  const posts = content.blog || [];
  const post = posts.find((p) => p.slug === slug) || posts[0];
  const others = posts.filter((p) => p.slug !== post?.slug).slice(0, 2);

  if (!post) {
    return (
      <div className="App bg-white"><SiteHeader /><div className="max-w-3xl mx-auto px-6 py-32 text-center"><p>Post not found.</p><Link to="/homi/blog" className="text-homi-goldDark font-bold">Back to Blog</Link></div><Footer /></div>
    );
  }

  return (
    <div className="App bg-white">
      <SiteHeader />
      <main>
        <PageBanner title={post.title} crumb="Blog" subtitle={post.category} />

        <article className="py-16 lg:py-20 bg-white">
          <div className="max-w-3xl mx-auto px-6">
            <div className="flex items-center gap-5 text-sm text-homi-body mb-8">
              <span className="flex items-center gap-1.5"><Calendar className="w-4 h-4 text-homi-goldDark" /> {post.date}</span>
              <span className="flex items-center gap-1.5"><User className="w-4 h-4 text-homi-goldDark" /> {post.author}</span>
              <span className="bg-homi-gold/15 text-homi-goldDark text-xs font-heading font-bold uppercase px-3 py-1 rounded-full">{post.category}</span>
            </div>
            <div className="rounded-3xl overflow-hidden shadow-xl mb-10">
              <img src={post.image} alt={post.title} className="w-full h-[420px] object-cover" />
            </div>
            {post.body.map((para) => (
              <p key={para.slice(0, 40)} className="text-lg text-homi-body leading-relaxed mb-6">{para}</p>
            ))}
            <div className="mt-10">
              <Link to="/homi/blog" className="inline-flex items-center gap-2 font-heading font-bold text-homi-goldDark hover:gap-3 transition-all"><ArrowLeft className="w-5 h-5" /> Back to all posts</Link>
            </div>
          </div>
        </article>

        {others.length > 0 && (
          <section className="py-16 bg-homi-light">
            <div className="max-w-5xl mx-auto px-6">
              <h3 className="font-heading font-bold text-2xl text-homi-black mb-6">More Articles</h3>
              <div className="grid sm:grid-cols-2 gap-6">
                {others.map((p) => (
                  <Link to={`/homi/blog/${p.slug}`} key={p.slug} className="group flex gap-4 bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all p-3">
                    <div className="w-28 h-24 rounded-xl overflow-hidden shrink-0"><img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" /></div>
                    <div className="flex flex-col justify-center">
                      <span className="text-homi-goldDark text-xs font-heading font-bold uppercase">{p.category}</span>
                      <h4 className="font-heading font-bold text-homi-black leading-snug mt-1 group-hover:text-homi-goldDark transition-colors">{p.title}</h4>
                      <span className="inline-flex items-center gap-1.5 text-sm font-heading font-bold text-homi-goldDark mt-2">Read <ArrowRight className="w-4 h-4" /></span>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        )}

        <ContactCta />
      </main>
      <Footer />
    </div>
  );
}
